import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import router from './router'
import i18n from './lang/index.js'
import '@/assets/scss/main.scss'

const app = createApp(App)

// Sentry
const replaysSessionSampleRate = import.meta.env
  .VITE_SENTRY_REPLAYS_SESSION_RATE
  ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_RATE)
  : 0
const replaysOnErrorSampleRate = import.meta.env.VITE_SENTRY_REPLAYS_ERROR_RATE
  ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ERROR_RATE)
  : 0
const tracesSampleRate = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
  ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE)
  : 0

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  debug: !!import.meta.env.VITE_SENTRY_DEBUG,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  enabled: !import.meta.env.VITE_SENTRY_DISABLED,

  integrations: [
    // new Sentry.BrowserTracing({
    //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    // }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
})

app.use(i18n).use(createPinia()).use(router).mount('#app')
